// extracted by mini-css-extract-plugin
export default {"button":"GVikt","tooltip-container":"zdTFt","tooltipContainer":"zdTFt","tooltip-title-container":"fEP0T","tooltipTitleContainer":"fEP0T","title":"fY4tM","image":"SWpw9"};